import { useEffect } from "react";
import Section from "@/components/Section";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "Quelle différence entre CrossFit, cross training et Hyrox ?", a: "Le CrossFit est une méthode d'entraînement brevetée, encadrée par des coachs certifiés, combinant haltéro, gym et cardio avec une programmation structurée. Le cross training est un terme générique pour tout entraînement croisé. Hyrox est une compétition de fitness alliant course à pied et exercices fonctionnels. Chez CrossFit Chistera, vous bénéficiez de l'encadrement et de la méthodologie officielle CrossFit." },
  { q: "C'est réservé aux gens costauds et aux compétiteurs ?", a: "Absolument pas ! Chaque mouvement, chaque charge est adaptable. On accueille des débutants complets, des personnes en reprise, des seniors… Le CrossFit, c'est justement l'art de s'adapter à chacun. Nos coachs sont là pour ça." },
  { q: "J'ai l'habitude d'aller en salle de sport classique. Pourquoi venir ici ?", a: "En salle classique, vous êtes souvent seul face aux machines. Ici, vous êtes coaché à chaque séance (max 10-12 personnes), la programmation est faite pour vous, et la communauté vous porte. Résultat : plus de motivation, plus de résultats, plus de plaisir." },
  { q: "On doit forcément faire des cours collectifs ?", a: "Non ! L'Open Gym vous permet de vous entraîner librement sous l'œil du coach. Vous pouvez aussi opter pour du coaching privé. Mais on vous prévient : les cours collectifs, c'est addictif !" },
  { q: "Combien de fois par semaine puis-je venir ?", a: "Selon votre abonnement : 1, 2, 3 cours/semaine ou illimité. On recommande 3 à 5 séances par semaine pour progresser, avec des jours de repos. Votre coach vous guidera." },
  { q: "Combien de coachs encadrent les cours ?", a: "Nous sommes une équipe de 5 coachs diplômés et certifiés. Vous êtes toujours encadré par au moins un coach par séance." },
  { q: "Je suis blessé, enceinte, j'ai un problème de santé… c'est pour moi ?", a: "Oui ! Nos coachs adaptent chaque séance à votre situation. Mouvements alternatifs, charges ajustées, exercices spécifiques… Prévenez-nous simplement avant la séance." },
  { q: "Je n'ai pas fait de sport depuis au moins 200 ans… c'est fait pour moi ?", a: "C'est certainement le meilleur choix et la meilleure façon de s'y (re)mettre ! Nos coachs sont fiers de permettre aux gens de se remettre en forme. La transformation est souvent radicale, et on y prend tous goût. 💪" },
  { q: "Proposez-vous d'autres services ?", a: "Oui ! Nous proposons du coaching privé, de la programmation personnalisée, du coaching entreprise, et nous avons accès à une nutritionniste pour un suivi global." },
  { q: "Combien de personnes par cours collectif ?", a: "Maximum 10 à 12 personnes par séance. C'est notre force : un coaching rapproché et une attention personnalisée pour chacun." },
  { q: "C'est quoi un drop-in ?", a: "Le drop-in est une séance à l'unité (15 € HT) destinée aux pratiquants de passage qui ne sont pas abonnés. Il suffit de nous contacter pour vérifier la disponibilité et réserver votre créneau." },
  { q: "Comment se passe la première séance ?", a: "Vous réservez votre essai gratuit via notre formulaire. Les coachs vous contactent pour organiser une séance de découverte adaptée à votre niveau. Vous avez droit à 2 séances d'essai gratuites pour découvrir la box." },
];

export default function FAQSection() {
  useEffect(() => {
    const tagId = "home-faq-jsonld";
    document.head.querySelectorAll(`script[data-seo="${tagId}"]`).forEach((s) => s.remove());
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.dataset.seo = tagId;
    s.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(s);
    return () => {
      document.head.querySelectorAll(`script[data-seo="${tagId}"]`).forEach((el) => el.remove());
    };
  }, []);

  return (
    <Section id="faq" className="bg-card">
      <div className="text-center mb-12">
        <span className="inline-block text-sm font-semibold text-gold tracking-wider mb-2 font-body normal-case">Vos questions, nos réponses</span>
        <h2 className="text-4xl md:text-5xl text-foreground">FAQ</h2>
      </div>

      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="bg-background border border-border rounded-lg px-6 data-[state=open]:shadow-md transition-shadow">
              <AccordionTrigger className="text-left text-base font-semibold text-foreground hover:no-underline font-body normal-case py-3">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground font-body normal-case leading-relaxed pb-3">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
